export { getMigrationsFingerprintStorageKey } from "#migrations";
